import {useQuery} from '@apollo/react-hooks';
import {ApolloError} from 'apollo-client';
import gql from 'graphql-tag';

///// Query definition

export const QUERY = gql`
  query RunLogLines(
    $projectName: String!
    $entityName: String
    $runName: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      run(name: $runName) {
        id
        logLines(last: 10000) {
          edges {
            node {
              id
              label
              level
              line
              timestamp
            }
          }
        }
      }
    }
  }
`;

interface Variables {
  entityName: string;
  projectName: string;
  runName: string;
}

interface Data {
  project: ProjectData;
}

interface ProjectData {
  run: RunData;
}

interface RunData {
  logLines: LogLines;
}

export interface LogLines {
  edges: Array<LogLineEdge>;
}

export interface LogLineEdge {
  node: LogLineNode;
}

export interface LogLineNode {
  id: string;
  label?: string;
  level: string;
  line: string;
  timestamp: string;
}

interface UseRunLogQueryParams {
  entityName: string;
  pollInterval: number;
  projectName: string;
  runName: string;
  skip?: boolean;
}

interface UseRunLogQueryResult {
  error?: ApolloError;
  loading: boolean;
  logLines: LogLines;
}

export function useRunLogQuery({
  entityName,
  pollInterval,
  projectName,
  runName,
  skip = false,
}: UseRunLogQueryParams): UseRunLogQueryResult {
  const {data, loading, error} = useQuery<Data, Variables>(QUERY, {
    pollInterval,
    skip,
    variables: {entityName, projectName, runName},
  });

  const logLines: LogLines = data?.project?.run?.logLines ?? {edges: []};

  return {
    error,
    loading,
    logLines,
  };
}
